import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types'
import ClipLoader from "react-spinners/ClipLoader";
import './Spinner.css';

const Container = styled.div`
    width: ${props => props.styles.width};
    display: flex;
    flex-direction: ${props => props.styles.flexDirection};
    justify-content: center;
    align-items: center;
    margin: ${props => props.styles.margin};
    align-self: ${props => props.styles.alignSelf};
`

const Text = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    font-weight: bolder;
    margin: 0.2rem;
`

const defaultStyle = {
    color: 'var(--focus-color)',
    size: '1rem',
    margin: 0,
    flexDirection: 'column',
    width: 'fit-content'
}

const Spinner = (props) => {
    const {
        text,
        styles
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    return (
        <Container styles={updatedStyle}>
            <ClipLoader loading={true} color={updatedStyle['color']} size={updatedStyle['size']}/>
            {text ? <Text>{text}</Text> : null}
        </Container>
    )
    
};

export default Spinner;

Spinner.propTypes = {
    text: PropTypes.string
}